import { network } from 'services/network';

export const getStoryImage = (params) => {
    const url = `api/bo/project/getStoryImage?id=${params.id}`;

    return network
        .post(url, null, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers.Accept = 'image/png';
                    }
                    return data;
                },
            ],
            responseType: 'blob',
        })
        .then((response) => {
            return response.data;
        });
};
